import { CBCT_SectionOrientation } from '@/shared/api/protocol-ts/model/dto_asset_common_pb';
import type {
  FullHeadMPRToothSliceOrientation,
  ToothParityDisplacementReference,
  ToothParitySliceRequest,
  ToothSlabMode,
  ToothSliceThickness,
} from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import {
  ENGINE_ORIENTATION_BY_SECTION,
  type ResolvedToothSlice,
  type ToothSliceGeometry,
} from '../config';

export const toEngineOrientation = (
  orientation: CBCT_SectionOrientation,
): FullHeadMPRToothSliceOrientation | null =>
  ENGINE_ORIENTATION_BY_SECTION[orientation] ?? null;

export const makeToothParityRequest = ({
  displacementReference,
  displacementSign,
  input,
  orientation,
  slabMode,
  slice,
  thickness,
}: {
  displacementReference: ToothParityDisplacementReference;
  displacementSign: 1 | -1;
  input: ToothSliceGeometry;
  orientation: FullHeadMPRToothSliceOrientation;
  slabMode: ToothSlabMode;
  slice: ResolvedToothSlice;
  thickness: ToothSliceThickness;
}): ToothParitySliceRequest => ({
  displacementReference,
  innerBox: input.roi.innerBox ?? undefined,
  anatomicalBasis: {
    MesioDistal: input.anatomicalBasis.mesioDistal,
    VestibuloOral: input.anatomicalBasis.vestibuloOral,
    Axial: input.anatomicalBasis.crownRoot,
  },
  displacementMm: slice.displacementMm * displacementSign,
  heightPx: slice.imageHeight,
  iso: input.numeration.iso,
  mmPerPixel: slice.mmPerPixel,
  orientation,
  origin: input.origin,
  outerBox: input.roi.outerBox,
  slabMode,
  thickness,
  volumeFileID: input.volumeFileID,
  widthPx: slice.imageWidth,
  window: { ww: slice.windowWidth, wc: slice.windowLevel },
});
